export default {


  check(code) {
    return env.API.get('/coupons/check/' + code);
  },
}
